import { useSelector } from 'react-redux';
import { Data } from 'signup-constants/signupData/Data';
import { getLoginUrl } from '../http-login/getLoginUrl';
import imageUrls from '../images/imageUrls';
import { getFallbackOnboardingUrl } from '../signup-completed-redirection/getFallbackOnboardingUrl';
import { getHublet, getIsNewUser } from '../store/app/selectors';
import { getPortalId } from '../store/auth/selectors';
import { getSignupDataValue } from '../store/signup-data/selectors';
import { useTracker } from '../tracking/useTracker';
import { ErrorKey } from './ErrorKey';
import StandardError from './StandardError';
import { getFullUrl } from 'hubspot-url-utils';
import { jsx as _jsx } from "react/jsx-runtime";
const ManualLoginView = () => {
  const portalId = useSelector(getPortalId);
  const hublet = useSelector(getHublet);
  const email = useSelector(state => getSignupDataValue(state, Data.Email));
  const isNewUser = useSelector(getIsNewUser);
  const errorKey = ErrorKey.LoginFailed;
  const Tracker = useTracker();
  const onClick = () => {
    Tracker.redirect({
      url: `${getFullUrl('app')}/login`
    });
  };
  return /*#__PURE__*/_jsx(StandardError, {
    errorKey: errorKey,
    href: getLoginUrl({
      redirectUrl: getFallbackOnboardingUrl(portalId, hublet, isNewUser),
      email,
      hublet
    }),
    imageURL: imageUrls.door,
    onSentenceWithLinkClick: onClick
  });
};
export default ManualLoginView;